<template lang="pug">
  .home
    //- Barra de navegación
    van-nav-bar(:title="$t('home.home')")
      van-icon(name="menu" slot="left" @click="openSidenav")

    .main
      //- Instalaciones de Clima
      InstallationsRow(
        v-if="installationsCount"
        :installations="installations"
        @showInfo="showInfo")

      //- Instalaciones de ACS
      InstallationsRow(
        v-if="installationsACSCount"
        :ACSMode="true"
        :installations="installationsACS"
        @showInfo="showInfo")

      //- Mensaje cuando no hay ninguna instalación
      .padding(v-if="!installationsCount")
        img.addUnit__img(src="@/assets/img/addUnitBluetooth.png")

        .addUnit__message.margin-double-bottom.margin-double-top
          .addUnit__message__title {{ $t('home.empty.title') }}
          | {{ isMobile ? $t('home.empty.message') : ''}}

        router-link.van-button.van-button--primary.van-button--large(
          v-if="isMobile"
          to="/main/addUnit")
          | {{ $t('sidenav.addUnit') }}

    //- Modal con la ventana de información del dispositivo
    van-popup.unit__webserver__popup(v-model="showDeviceInfo")
      DeviceModalInfo(
        v-if="showDeviceInfo"
        :mac="deviceMacInfo"
        :installationID="installationIDInfo"
        @close="hideInfo()")

    //- Modal con los errores
    van-popup.unit__webserver__popup(v-model="showDevicesError")
      DeviceModalError(
        v-if="showDevicesError"
        :unitErrors="devicesError"
        @close="hideError()")
</template>

<script>
import InstallationsRow from '@/components/Home/InstallationsRow.vue';
import DeviceModalInfo from '@/components/DeviceModalInfo.vue';
import DeviceModalError from '@/components/DeviceModalError.vue';
import { mapGetters, mapActions } from 'vuex';
import { parseBoolean } from '@/utils/sanitaze.utils';
import { IS_MOBILE } from '@/app.config';

export default {
  components: { InstallationsRow, DeviceModalInfo, DeviceModalError },
  data() {
    return {
      showDeviceInfo: false,
      showDevicesError: false,
      deviceMacInfo: '',
      installationIDInfo: '',
      isMobile: IS_MOBILE,
    };
  },
  computed: {
    ...mapGetters({
      getInstallations: 'unitsModule/getInstallations',
      devicesError: 'unitsModule/getDevicesError',
    }),

    /**
     * Devuelve todas las instalaciones
     */
    installations() {
      return this.getInstallations();
    },

    /**
     * Devuelve todas las instalaciones con ACS
     */
    installationsACS() {
      return this.getInstallations(true);
    },

    /**
     * Devuelve el número de instalaciones de Aire
     *
     * @return {Integer} - Número de instalaciones
     */
    installationsCount() {
      if (!this.installations) return 0;
      return Object.keys(this.installations).length;
    },

    /**
     * Devuelve el número de instalaciones de ACS
     *
     * @return {Integer} - Número de instalaciones
     */
    installationsACSCount() {
      if (!this.installationsACS) return 0;
      return Object.keys(this.installationsACS).length;
    },
  },

  watch: {
    /**
     * Compruebo si hay errores para mostrar un modal con un listado de errores
     */
    devicesError: {
      deep: true,
      handler() {
        const storeShowError = parseBoolean(window.localStorage.getItem('devicesError'));

        if (this.devicesError && this.devicesError.length && !storeShowError) {
          setTimeout(() => {
            this.showDevicesError = true;
          }, 1000);
        }
      },
    },
  },

  methods: {
    ...mapActions({
      openSidenav: 'globalModule/openSidenav',
    }),

    /**
     * Muestra un modal con información del dispositivo
     *
     */
    showInfo(data) {
      this.deviceMacInfo = data.mac;
      this.installationIDInfo = data.installationID;
      this.showDeviceInfo = true;
    },

    /**
     * Oculta un modal con información del dispositivo
     *
     */
    hideInfo() {
      this.deviceMacInfo = '';
      this.installationIDInfo = '';
      this.showDeviceInfo = false;
    },

    hideError() {
      this.showDevicesError = false;
      window.localStorage.setItem('devicesError', true);
    },
  },

  mounted() {
    const storeShowError = parseBoolean(window.localStorage.getItem('devicesError'));

    if (this.devicesError && this.devicesError.length && !storeShowError) {
      setTimeout(() => {
        this.showDevicesError = true;
      }, 1000);
    }
  },
};
</script>
